import type * as React from 'react';
import { AttentionList, TodayLayout } from '@redhand/ui';
import { demoAttention, demoTasks } from '../../demo-data.js';

const severityLabels = { info: 'Info', warning: 'Pozor', critical: 'Kritické' } as const;

/** Vzorova obrazovka: ukolovy Dnesek (REOS archetyp — makler rano vi, co delat). */
export function DnesekSample(): React.JSX.Element {
  return (
    <TodayLayout
      title="Dnešek"
      date="pátek 29. srpna 2026"
      attention={
        <div className="rh-card">
          <h2 style={{ margin: '0 0 8px', fontSize: 16 }}>Co hoří</h2>
          <AttentionList
            ariaLabel="Co hoří"
            severityLabels={severityLabels}
            items={demoAttention.map((a) => ({ ...a, action: { label: 'Vyřešit', onAction: () => {} } }))}
          />
        </div>
      }
      aside={
        <>
          <div className="rh-card">
            <h2 style={{ margin: '0 0 8px', fontSize: 16 }}>Dnešní schůzky</h2>
            <ul style={{ margin: 0, paddingLeft: 20 }}>
              <li>10:00 — prohlídka, Miroslava (byt 3+kk, České Budějovice)</li>
              <li>15:30 — podpis rezervace, Đorđe Kovačević</li>
            </ul>
          </div>
          <div className="rh-card">
            <h2 style={{ margin: '0 0 8px', fontSize: 16 }}>Zkratky</h2>
            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
              <button type="button" className="rh-btn rh-btn--primary">Nabrat nemovitost</button>
              <button type="button" className="rh-btn">Nová poptávka</button>
            </div>
          </div>
        </>
      }
    >
      <div className="rh-card">
        <h2 style={{ margin: '0 0 12px', fontSize: 16 }}>Úkoly na dnešek</h2>
        <ul style={{ listStyle: 'none', margin: 0, padding: 0, display: 'flex', flexDirection: 'column', gap: 12 }}>
          {demoTasks.map((t) => (
            <li key={t.id} style={{ display: 'flex', gap: 12, alignItems: 'flex-start' }}>
              <input type="checkbox" aria-label={`Hotovo: ${t.title}`} style={{ marginTop: 4 }} />
              <div style={{ minWidth: 0 }}>
                <p style={{ margin: 0, fontWeight: 550 }}>{t.title}</p>
                <p style={{ margin: '2px 0 0', fontSize: 13, color: 'var(--rh-text-muted)' }}>
                  {t.context} · {t.due}
                </p>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </TodayLayout>
  );
}
